"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Sidebar = exports.closeAllDrawers = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _shapes = require("../shapes");

var _react = _interopRequireWildcard(require("react"));

var _ChevronLeft = _interopRequireDefault(require("@material-ui/icons/ChevronLeft"));

var _Drawer = _interopRequireDefault(require("../../Drawer"));

var _Button = _interopRequireDefault(require("../../Button"));

var _NavigationSection = _interopRequireDefault(require("./NavigationSection"));

var _OrganizationList = _interopRequireDefault(require("./OrganizationList"));

var _ProductLogo = _interopRequireDefault(require("./ProductLogo"));

var _ProductNavSection = _interopRequireDefault(require("./ProductNavSection"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _withWidth = require("@material-ui/core/withWidth");

var _styles = require("./styles");

var _ThemeHelper = require("../../Utilities/ThemeHelper");

var _styles2 = require("@material-ui/core/styles");

var _ProductList = _interopRequireDefault(require("./ProductList"));

var _OrganizationButton = _interopRequireDefault(require("./OrganizationButton"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var closeAllDrawers = function closeAllDrawers() {
  var drawerWrappers = document.querySelectorAll(".prmbl-sidebar-drawerBackdrop");

  if (drawerWrappers.length) {
    drawerWrappers.forEach(function (wrapper) {
      return wrapper.click();
    });
  }
};

exports.closeAllDrawers = closeAllDrawers;

var Sidebar = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Sidebar, _Component);

  var _super = _createSuper(Sidebar);

  function Sidebar(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Sidebar);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleSubMenu", function (section, key) {
      _this.setState(function (prevState) {
        var isOpen = false;
        var openSection = "";
        var openSubNav = "";

        if (section && key && !(section === prevState.openSection && key === prevState.openSubNav)) {
          isOpen = true;
          openSection = section;
          openSubNav = key;
        }

        return {
          subNavOpen: isOpen,
          openSection: openSection,
          openSubNav: openSubNav
        };
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleProductNavSection", function (theState) {
      // If theState is a boolean, set the state to that value
      if (typeof theState === "boolean") {
        if (_this.state.productNavSectionOpen !== theState) {
          _this.setState({
            productNavSectionOpen: theState
          });
        }
      } // Otherwise just toggle
      else {
          _this.setState({
            productNavSectionOpen: !_this.state.productNavSectionOpen
          });
        }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleOrganizationList", function (theState) {
      // If theState is a boolean, set the state to that value
      if (typeof theState === "boolean") {
        if (_this.state.organizationListOpen !== theState) {
          _this.setState({
            organizationListOpen: theState
          });
        }
      } // Otherwise just toggle
      else {
          _this.setState({
            organizationListOpen: !_this.state.organizationListOpen
          });
        }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderNavigation", function () {
      var _this$props = _this.props,
          id = _this$props.id,
          navigationSections = _this$props.navigationSections;
      var _this$state = _this.state,
          openSection = _this$state.openSection,
          openSubNav = _this$state.openSubNav;
      return Object.keys(navigationSections).map(function (key, index) {
        var section = navigationSections[key];
        var sectionId = "".concat(id, "-main-nav-section-").concat(key);
        return /*#__PURE__*/_react.default.createElement(_NavigationSection.default, {
          id: sectionId,
          key: sectionId,
          sectionKey: key,
          openSection: openSection,
          openSubNav: openSubNav,
          section: section,
          toggleSubMenu: _this.toggleSubMenu,
          isSelected: section.isSelected
        });
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderSubNav", function () {
      var _this$props2 = _this.props,
          id = _this$props2.id,
          navigationSections = _this$props2.navigationSections;
      var _this$state2 = _this.state,
          openSection = _this$state2.openSection,
          openSubNav = _this$state2.openSubNav;

      if (openSection !== "" && openSubNav !== "") {
        var section = navigationSections[openSection].items[openSubNav];
        var subSections = section.subNavSections;
        var subSectionId = "".concat(id, "-sub-nav-section");
        return subSections.map(function (subSection, index) {
          return /*#__PURE__*/_react.default.createElement(_NavigationSection.default, {
            key: "".concat(subSectionId, "-").concat(index),
            id: "".concat(subSectionId, "-").concat(index),
            sectionKey: openSection,
            openSection: openSection,
            openSubNav: "",
            section: {
              title: subSection.title,
              items: subSection.items,
              subtitle: subSection.subtitle
            },
            toggleSubMenu: _this.toggleSubMenu,
            isSelected: section.isSelected
          });
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "render", function () {
      var _this$props3 = _this.props,
          id = _this$props3.id,
          classes = _this$props3.classes,
          productLogo = _this$props3.productLogo,
          width = _this$props3.width,
          mainNavOpen = _this$props3.mainNavOpen,
          hideMainNav = _this$props3.hideMainNav,
          productNavSections = _this$props3.productNavSections,
          identityServerSdk = _this$props3.identityServerSdk,
          currentOrg = _this$props3.currentOrg,
          currentOrgSettings = _this$props3.currentOrgSettings,
          onOrgSelect = _this$props3.onOrgSelect,
          children = _this$props3.children,
          disableProductList = _this$props3.disableProductList,
          type = _this$props3.type,
          product = _this$props3.product,
          shouldCollapseMenu = _this$props3.shouldCollapseMenu,
          navigationSections = _this$props3.navigationSections,
          productListOpen = _this$props3.productListOpen,
          toggleProductList = _this$props3.toggleProductList;
      var _this$state3 = _this.state,
          subNavOpen = _this$state3.subNavOpen,
          organizationListOpen = _this$state3.organizationListOpen,
          openSubNav = _this$state3.openSubNav,
          openSection = _this$state3.openSection;
      var isLargeScreen = (0, _withWidth.isWidthUp)("md", width);
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Drawer.default, {
        id: id + "-main-nav",
        PaperProps: {
          component: "nav"
        },
        classes: {
          docked: classes.docked,
          paper: (0, _classnames.default)(classes.wrapper, (0, _defineProperty2.default)({}, classes.subNavOpen, subNavOpen), (0, _defineProperty2.default)({}, classes.offsetTopBar, !isLargeScreen || shouldCollapseMenu), "prmbl-sidebar")
        },
        open: isLargeScreen && !shouldCollapseMenu ? true : mainNavOpen,
        onClose: hideMainNav,
        modalProps: {
          disablePortal: true,
          classes: {
            root: classes.modal
          },
          BackdropProps: {
            invisible: true,
            classes: {
              root: "prmbl-sidebar-drawerBackdrop"
            }
          }
        },
        variant: isLargeScreen && !shouldCollapseMenu ? "persistent" : "temporary"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(classes.shadow, (0, _defineProperty2.default)({}, classes.shadowShowing, subNavOpen))
      }), /*#__PURE__*/_react.default.createElement(_ProductLogo.default, {
        onClick: !disableProductList ? toggleProductList : undefined,
        isOpen: !disableProductList ? productListOpen : undefined,
        id: id + "-productLogo",
        type: type,
        currentOrg: currentOrg,
        currentOrgSettings: currentOrgSettings,
        product: product,
        productLogo: productLogo
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: classes.fillHeight
      }, !disableProductList && /*#__PURE__*/_react.default.createElement(_ProductList.default, {
        id: id + "-productList",
        identityServerSdk: identityServerSdk,
        open: productListOpen,
        onToggle: toggleProductList
      }), /*#__PURE__*/_react.default.createElement(_ProductNavSection.default, {
        id: id + "-productNavSection",
        productNavSections: productNavSections,
        isOpen: _this.state.productNavSectionOpen,
        onToggle: _this.toggleProductNavSection
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)((0, _defineProperty2.default)({}, classes.hideOverflow, _this.state.organizationListOpen), classes.scrollWrapper)
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(classes.navigation)
      }, children ? children : _this.renderNavigation()), (onOrgSelect || currentOrg) && /*#__PURE__*/_react.default.createElement(_OrganizationList.default, {
        id: id + "-organizationList",
        open: organizationListOpen,
        onToggle: _this.toggleOrganizationList,
        currentOrg: currentOrg,
        currentOrgSettings: currentOrgSettings,
        identityServerSdk: identityServerSdk,
        onOrgSelect: onOrgSelect
      })), (onOrgSelect || currentOrg) && /*#__PURE__*/_react.default.createElement(_OrganizationButton.default, {
        id: id + "-organizationButton",
        onClick: _this.toggleOrganizationList,
        open: organizationListOpen,
        currentOrg: currentOrg,
        showOrgSwitcher: onOrgSelect
      }))), /*#__PURE__*/_react.default.createElement(_Drawer.default, {
        id: "".concat(id, "-sub-nav"),
        PaperProps: {
          component: "nav"
        },
        classes: {
          paper: classes.subOuterWrapper,
          docked: classes.subDocked
        },
        open: subNavOpen,
        onClose: function onClose() {
          return _this.toggleSubMenu();
        },
        modalProps: {
          disablePortal: true,
          BackdropProps: {
            invisible: true,
            classes: {
              root: "prmbl-sidebar-drawerBackdrop"
            }
          }
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: classes.subHeader
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        type: "icon",
        onClick: _this.toggleSubMenu,
        title: "Close menu"
      }, /*#__PURE__*/_react.default.createElement(_ChevronLeft.default, null))), openSection && openSubNav && navigationSections[openSection].items[openSubNav].subNavHeader ? navigationSections[openSection].items[openSubNav].subNavHeader : null, /*#__PURE__*/_react.default.createElement("div", {
        className: classes.subInnerWrapper
      }, _this.renderSubNav())));
    });
    _this.state = {
      subNavOpen: false,
      productListOpen: false,
      organizationListOpen: false,
      productNavSectionOpen: false,
      openSection: "",
      openSubNav: ""
    };
    return _this;
  }

  return Sidebar;
}(_react.Component);

exports.Sidebar = Sidebar;
(0, _defineProperty2.default)(Sidebar, "propTypes", {
  /**
   * The html id
   */
  id: _propTypes.default.string.isRequired,

  /**
   * @ignore
   *
   * Utilizing this to pass styles from Page component
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * Custom items to render in sidebar
   */
  children: _propTypes.default.node,

  /**
   * The current organization's name
   */
  currentOrg: _propTypes.default.string,

  /**
   * The current organization's branding settings
   */
  currentOrgSettings: _propTypes.default.shape({
    name: _propTypes.default.string,
    id: _propTypes.default.string,
    settings: _propTypes.default.object
  }),

  /**
   * What to do when the organization is selected.
   */
  onOrgSelect: _propTypes.default.func,

  /**
   * Function to call in order to hide the main navigation on smaller screens.
   */
  hideMainNav: _propTypes.default.func.isRequired,

  /**
   * Is the main nav open
   */
  mainNavOpen: _propTypes.default.bool.isRequired,

  /**
   * The definition for navigation sections.
   *
   * Did an object instead of an array so it would be easier to map up sub nav items later
   */
  navigationSections: _shapes.NavigationSections.isRequired,

  /**
   * The definition for product navigation sections.
   *
   */
  productNavSections: _shapes.ProductNavSections.isRequired,

  /**
   * The identitySeverSdk object. Requires accessToken, identityServerBaseUrl, and idToken.
   * Used to get the user's products and information.
   *
   * If no user is specified, a blank product list will be shown and a user avatar will be hidden.
   */
  identityServerSdk: _propTypes.default.object,

  /**
   * The html node to render as the product logo
   */
  productLogo: _propTypes.default.node,

  /**
   * Contains the current width of the view port
   */
  width: _propTypes.default.string.isRequired,

  /**
   * If `true` the product list will not render
   */
  disableProductList: _propTypes.default.bool,

  /**
   * The type of page, which affects what logo and color is used
   */
  type: _propTypes.default.oneOf(["internal", "external"]),

  /**
   * Sets product colors and logo automatically. Can be overridden by primaryHex and productLogo
   */
  product: _propTypes.default.oneOf(Object.keys(_ThemeHelper.themes)),

  /**
   * If `true` the menu will always collapse into a button, otherwise only on small screens
   */
  shouldCollapseMenu: _propTypes.default.bool,

  /**
   * The function to toggle the product list open/close state
   */
  toggleProductList: _propTypes.default.func.isRequired,

  /**
   * The state of the product list
   */
  productListOpen: _propTypes.default.bool.isRequired
});
(0, _defineProperty2.default)(Sidebar, "defaultProps", {
  navigationSections: {},
  productNavSections: []
});

var _default = (0, _styles2.withStyles)(_styles.styles)(Sidebar);

exports.default = _default;